import { render, staticRenderFns } from "./PoliticaDePrivacidad.vue?vue&type=template&id=06bff2a9&scoped=true&"
import script from "./PoliticaDePrivacidad.vue?vue&type=script&lang=js&"
export * from "./PoliticaDePrivacidad.vue?vue&type=script&lang=js&"
import style0 from "./PoliticaDePrivacidad.vue?vue&type=style&index=0&id=06bff2a9&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bff2a9",
  null
  
)

export default component.exports